<template>
  <div id="container" class="sbook_st_detail">
    <!-- Location START -->
    <div class="location_wrap">
      <div class="location">
        <span>{{ $t('views.selfbook.selfbookcreate.4565') }}</span>
        <span class="svg_next">></span>
        <div v-on-clickaway="closeListMenu" class="current">
          <div class="select_area">
            <div class="select_item" :class="{ active: showListMenu }">
              <button
                type="button"
                class="select_option"
                @click="toggleListMenu"
              >
                <span class="txt">{{
                  $t('views.selfbook.selfbookcreate.4469')
                }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Location END -->

    <!-- 도서 기본 정보 START -->
    <!--<SelfbookDetailHead :selfbook="selfbook" /> -->
    <div class="section full">
      <div class="inner">
        <div class="detail_book">
          <div class="eplist sbook">
            <!-- SelfBook Cover Image Start -->
            <div>
              <BaseSelfbook :selfbook="selfbook" mode="edit" />
              <!-- TODO: @Tim: Switch to BaseButton later when refactoring -->
              <!-- TODO: @Stan need to confirm whether this button belongs on create page
                as we are not sure whether this page or upload page is the first page of selfbook
                create flow.
              -->
              <!--
              <div class="preview_btn_wrap">
                <a target="_blank" class="an_a"
                  ><span class="c_icon ico_view_sbook"></span
                  ><span class="an_t">{{ $t('views.selfbook.selfbookcreate.7353') }}</span></a
                >
              </div>
              -->
            </div>
            <!-- SelfBook Cover Image End -->

            <!-- SelfBook Fields Input Start -->
            <div>
              <div class="editer_form">
                <div class="editer_text_wrap n_line">
                  <input
                    id="modify-tile"
                    v-model="selfbook.title"
                    class="editer_input_t"
                    name="title"
                    :placeholder="$t('views.selfbook.selfbookcreate.8151')"
                  />
                </div>

                <div class="editer_text_wrap n_line">
                  <input
                    v-model="selfbook.author"
                    class="editer_input_t"
                    name="author"
                    style="width: 144px;"
                    :placeholder="$t('views.selfbook.selfbookcreate.5918')"
                  />
                  <span class="gap">/</span>
                  <input
                    v-model="selfbook.publisher"
                    class="editer_input_t"
                    name="publisher"
                    style="width: 144px;"
                    :placeholder="$t('views.selfbook.selfbookcreate.3780')"
                  />
                </div>

                <div class="editer_text_wrap n_line price_wrap">
                  <div class="th">
                    <span>{{ $t('views.selfbook.selfbookcreate.1026') }}</span>
                  </div>
                  <div class="td">
                    <input
                      :value="0"
                      class="editer_input_t"
                      name="price"
                      :title="$t('views.selfbook.selfbookcreate.1727')"
                      type="number"
                      :placeholder="$t('views.selfbook.selfbookcreate.6025')"
                      style="width: 120px;"
                      oninput="validity.valid || (value = '')"
                      readonly
                    />
                    <!-- Not sure why this is here. Needs confirmation -->
                    <!-- <span class="percent"
                        >{{ $t('views.selfbook.selfbookcreate.2907') }}<span class="arrow">할인</span></span
                      > -->
                    <div class="ar">
                      <span>
                        <vue-intl-numberformat
                          locale="ko-KR"
                          class="price"
                          format-style="currency"
                          :currency="getCurrency.currency"
                          :number="formatPrice"
                        />
                      </span>
                    </div>
                    <div class="guide">
                      <p>{{ $t('views.selfbook.selfbookcreate.2') }}</p>
                      <p>{{ $t('views.selfbook.selfbookcreate.4466') }}</p>
                    </div>
                  </div>
                </div>

                <!-- Edit Button -->
                <div
                  v-if="!showHeadEdit && $route.path !== '/selfbook/create'"
                  class="btn_wrap atr"
                >
                  <a class="an_a" @click="editHead"
                    ><span class="c_icon ico_edit_sbook"></span
                    ><span class="an_t">{{
                      $t('views.selfbook.selfbookcreate.8406')
                    }}</span></a
                  >
                </div>

                <!-- Selfbook.color selector -->
                <div class="editer_select_cover">
                  <p>{{ $t('views.selfbook.selfbookcreate.4313') }}</p>
                  <div class="text_label">
                    <label class="cursor"
                      ><input
                        v-model="selfbook.color"
                        type="radio"
                        name="select_cover"
                        class="chk_cover display-none"
                        value="A"
                        checked
                      /><em></em
                      ><span class="blind">{{
                        $t('views.selfbook.selfbookcreate.blue')
                      }}</span></label
                    >
                    <label class="cursor"
                      ><input
                        v-model="selfbook.color"
                        type="radio"
                        name="select_cover"
                        class="chk_cover display-none"
                        value="B"
                      /><em></em
                      ><span class="blind">{{
                        $t('views.selfbook.selfbookcreate.orange')
                      }}</span></label
                    >
                    <label class="cursor"
                      ><input
                        v-model="selfbook.color"
                        type="radio"
                        name="select_cover"
                        class="chk_cover display-none"
                        value="C"
                      /><em></em
                      ><span class="blind">{{
                        $t('views.selfbook.selfbookcreate.green')
                      }}</span></label
                    >
                  </div>
                </div>
              </div>

              <!-- Buttons to save or cancel edits made -->
              <div v-if="showHeadEdit" class="btn_wrap ar">
                <div>
                  <button class="box_btn dull" @click="editHead">
                    <span class="an_t">{{
                      $t('library.deletemodal.cancel')
                    }}</span>
                  </button>
                </div>
                <div>
                  <button class="box_btn" @click="saveHeadChanges">
                    <span class="an_t">{{
                      $t('library.deletemodal.save')
                    }}</span>
                  </button>
                </div>
              </div>
            </div>
            <!-- SelfBook Fields Input End -->
          </div>
        </div>
      </div>
    </div>
    <!-- 도서 기본 정보 END -->

    <!-- 도서 세부 정보 -->
    <div class="section fill">
      <div class="inner">
        <div class="detail_book_introduce">
          <!-- Detail Box 품목 -->
          <BookCategoryBox mode="create" :categories="categories" />

          <TextareaBox
            :title="$t('views.selfbook.selfbookcreate.9950')"
            mode="create"
            :text.sync="selfbook.description"
          />
          <TextareaBox
            :title="$t('views.selfbook.selfbookcreate.5510')"
            mode="create"
            :text.sync="selfbook.contents"
          />

          <!-- TODO: @Tim Change to BaseButton later -->
          <div class="modify_save_wrap">
            <a
              class="box_btn"
              :class="{ dull: !isValid }"
              @click="createSelfbook()"
              ><span class="an_t">저장</span></a
            >
          </div>
        </div>
      </div>
    </div>
    <!-- ERROR MODAL -->
    <transition v-on-clickaway="toggleErrorModal" name="modal-fade">
      <Modal v-if="showErrorModal" @close="toggleErrorModal">
        <div class="ly_pop_wrap">
          <div class="ly_pop_content ly_pop_msg ly_txt">
            <div class="ly_pop_head">
              <a class="btn_ly_close svg_close" @click="toggleErrorModal"
                ><span>{{ $t('library.deletemodal.close') }}</span></a
              >
            </div>
            <div class="ly_inner">
              <p>
                {{ errorMessage }}
              </p>
              <div class="btnWrap">
                <button class="box_btn w-full" @click="toggleErrorModal">
                  <span class="an_t">{{
                    $t('library.deletemodal.close')
                  }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </transition>
  </div>
</template>

<script>
import TextareaBox from '@/components/library/TextareaBox.vue'
import BookCategoryBox from '@/components/library/BookCategoryBox.vue'
import BaseSelfbook from '@/components/base/BaseSelfbook.vue'

import { mapGetters } from 'vuex'

import { SELFBOOK_CREATE } from '@/store/types'

export default {
  name: 'SelfbookCreate',
  components: {
    BookCategoryBox,
    TextareaBox,
    BaseSelfbook
  },
  data() {
    return {
      showHeadEdit: false,
      showReasonModal: false,
      showConfirmEditModal: false,
      activeIndex: undefined,
      showErrorModal: false,
      errorMessage: '',
      dropdowns: [
        {
          id: 1
        },
        {
          id: 2
        },
        {
          id: 3
        }
      ],
      showListMenu: false,
      categories: [
        {
          parent: {},
          child: {},
          children: {}
        }
      ],
      selfbook: {
        categories: [],
        id: '12345',
        title: '나의 셀프북',
        color: 'A',
        status: 'ED',
        price: '',
        date: '',
        size: '',
        pageCount: '',
        description: '',
        contents: ''
      }
    }
  },
  computed: {
    ...mapGetters(['getCurrency']),

    isValid() {
      if (
        !this.selfbook.title ||
        //!this.selfbook.price ||
        !this.categories[0].parent ||
        !this.selfbook.description ||
        !this.selfbook.contents
      )
        return false
      return true
    }
  },
  mounted() {
    if (!this.$route.params.contentInfo) {
      this.$router.push({ name: 'selfbook_upload' })
    }
  },
  methods: {
    async createSelfbook() {
      if (!this.isValid) {
        return
      }

      /*
        TODO: @stan Refactor this to actions
      */
      const { selfbook, categories } = this

      const contentInfo = this.$route.params.contentInfo

      contentInfo.fileNm = contentInfo.url.split('/')[
        contentInfo.url.split('/').length - 1
      ]

      const newSelfbook = {
        bookNm: selfbook.title,
        bookDesc: selfbook.description,
        // Price will always be 0 for now.
        bookPrice: {
          listPrice: 0
        },
        bookIndex: selfbook.contents,
        author: selfbook.author,
        publisher: selfbook.publisher,
        thumbTp: selfbook.color,
        catgryList: categories.map((cat) => {
          return Object.keys(cat)
            .map((key) => (cat[key] ? cat[key].catgryCd : null))
            .filter(Boolean)
            .join('@')
        }),
        contentInfo
      }

      try {
        await this.$store.dispatch(SELFBOOK_CREATE, newSelfbook)

        this.$router.push({ name: 'selfbook' })
      } catch (err) {
        this.toggleErrorModal(
          `[${err.response.data.errorState.code}] ${err.response.data.errorState.message}`
        )
      }
    },
    toggleErrorModal(errorMessage) {
      if (errorMessage) {
        this.errorMessage = errorMessage
      }
      this.showErrorModal = !this.showErrorModal
    },
    formatPrice(value) {
      let val = value / 1
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    closeListMenu() {
      this.showListMenu = false
    },
    toggleListMenu() {
      this.showListMenu = !this.showListMenu
    }
  },
  setActive(idx) {
    this.activeIndex = idx
  }
}
</script>

<style lang="scss" scoped>
// REMOVES up/down arrows from number input
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}

.editer_form {
  .editer_select_cover {
    .text_label {
      input[value='A'] + em {
        // background: url('~@/assets/images/cover_chk_blue.png') center center
        //   no-repeat;
      }
      input[value='B'] + em {
        // background: url('~@/assets/images/cover_chk_orange.png') center center
        //   no-repeat;
      }
      input[value='C'] + em {
        // background: url('~@/assets/images/cover_chk_green.png') center center
        //   no-repeat;
      }
    }
  }
  .editer_text_wrap {
    input:read-only {
      background: #f0f5fa;
      border: 1px solid rgba(119, 136, 153, 0.6);
      font-size: 15px;
      line-height: 28px;
      letter-spacing: -0.03em;
      color: #777777;
    }
  }
}
</style>
